/* 가로 메뉴가 보이기 시작하는 폭. **CSS 와 같은 값이어야 한다.**
   ⚠ 여기가 1200, CSS 가 1060 이었다. 그 사이(1060~1199)에서는 BRAND 메뉴가
      **보이는데 눌러도 안 열렸다** (2026-09-13 실측: 1199·1100·1060 에서 판이 안 열림).
      기준이 두 곳에 따로 적혀 있으면 반드시 어긋난다 — 한 곳에 두고 여기서만 고친다.
   CSS 쪽 정본: assets/ue-header.css 의 `min-width: 1060px` (sections/ue-header.liquid 도 같다). */
const 가로메뉴폭 = 1060;

/* ------------------------------------------------------------------
 * UE-CUSTOM 헤더 검색 (슬로우레시피 리뉴얼 2026-09-11)
 *
 * 목적: 돋보기를 눌러 드로어를 여는 단계를 없앤다.
 *       헤더에 항상 떠 있는 입력창에 글자를 치면 그 자리 아래로 결과가 뜨고,
 *       엔터를 치면 평소대로 /search 로 간다.
 *
 * Focal 코어 파일은 건드리지 않는다. 테마가 이미 쓰는 것만 재사용한다:
 *   - window.themeVariables.routes (snippets/js-variables.liquid)
 *   - sections/predictive-search.liquid  (결과 마크업)
 *   - sections/predictive-search-compatibility.liquid (예측 검색 미지원 언어)
 *
 * 5차(2026-09-11 13:0x) — 짧은 플레이스홀더 교체 장치(_watchPlaceholder)를 **지웠다.**
 *   그것은 4차의 한 줄 배치(안B · 알약 폭 150px)에서만 쓰던 것이다.
 *   5차에서 의장이 두 줄 배치를 확정해 알약이 화면 폭 전체가 되면서 긴 문장이 그대로 들어간다.
 *   liquid 가 12:57 에 이미 data-ue-placeholder-short 속성과 설정을 지웠는데
 *   이 파일에만 코드가 남아 있었다 — 죽은 코드이자 liquid 주석과 어긋나는 기록이라 함께 지운다.
 * ------------------------------------------------------------------ */

(() => {
  if (window.customElements.get('ue-predictive-search')) {
    return;
  }

  class UePredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.formElement = this.querySelector('form');
      this.inputElement = this.querySelector('input[name="q"]');
      this.panelElement = this.querySelector('.ue-search__panel');
      this.resultsElement = this.querySelector('.ue-search__results');
      this.loadingElement = this.querySelector('.ue-search__loading');
      this.footerElement = this.querySelector('.ue-search__footer');
      this.menuElement = this.querySelector('.ue-search__menu-list');
      this.resetElement = this.querySelector('[data-action="ue-reset-search"]');

      this.abortController = null;
      this.lastTerm = null;

      /* 검색 패널이 열려 있는 동안 메뉴줄을 감추기 위해 헤더에 표시를 남긴다.
         패널 모서리가 메뉴 글자를 세로로 자르고(1차 4 · 2차 M-2),
         ALL 단추 윗면이 패널 위로 삐져나오던 것(2차 M-1)을 함께 없앤다. */
      this.headerElement = this.closest('.ue-header');

      this._watchDrawers();
      this._watchCartCount();

      this.inputElement.addEventListener('input', this._debounce(this._onInput.bind(this), 200));
      this.inputElement.addEventListener('focus', this._onFocus.bind(this));
      this.inputElement.addEventListener('keydown', this._onKeyDown.bind(this));

      if (this.resetElement) {
        this.resetElement.addEventListener('click', this._onReset.bind(this));
      }

      this._onDocumentClick = (event) => {
        if (!this.contains(event.target)) {
          this.close();
        }
      };

      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('focusin', this._onDocumentClick);

      /* 검색 결과 페이지처럼 입력창에 검색어가 들어 있는 채로 열리는 화면에서는
         지우기 X 가 처음부터 보여야 한다 (1차 육안 검수 5). */
      if (this.resetElement) {
        this.resetElement.hidden = this.inputElement.value.trim() === '';
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('focusin', this._onDocumentClick);

      if (this.drawerObserver) {
        this.drawerObserver.disconnect();
      }

      if (this.cartCountObserver) {
        this.cartCountObserver.disconnect();
      }
    }

    get limit() {
      return parseInt(this.getAttribute('results-limit') || '5', 10);
    }

    open() {
      this.panelElement.hidden = false;
      this.inputElement.setAttribute('aria-expanded', 'true');

      if (this.headerElement) {
        this.headerElement.classList.add('ue-header--searching');
      }
    }

    close() {
      this.panelElement.hidden = true;
      this.inputElement.setAttribute('aria-expanded', 'false');

      if (this.headerElement) {
        this.headerElement.classList.remove('ue-header--searching');
      }
    }

    /* 서랍(햄버거·ALL 단추)이 열려 있는 동안에는 검색줄·메뉴줄을 감춘다.
       딤 위로 검색 밑줄 토막과 지우기 X 만 떠 있던 것을 없앤다 (1차 12·13).
       서랍은 테마가 body 밑으로 옮기므로 open 속성을 지켜본다. */
    _watchDrawers() {
      if (!this.headerElement) {
        return;
      }

      const sync = () => {
        /* ⚠ `.drawer` 를 통째로 보면 **미니 장바구니(cart-drawer#mini-cart)** 까지 걸린다.
           담기를 누르면 장바구니가 열리면서 메뉴줄이 통째로 사라졌다
           (2026-09-28 의장 발견 · 실측: 헤더에 ue-header--drawer-open 이 붙고 메뉴줄 opacity 0).
           메뉴줄을 감추는 이유는 **왼쪽에서 열리는 서랍이 메뉴 첫 글자를 덮기 때문**이다.
           장바구니는 오른쪽에서 열려 메뉴를 가리지 않는다 — 그래서 뺀다. */
        const anyOpen = Array.from(document.querySelectorAll('#mobile-menu-drawer, .drawer'))
          .filter((drawer) => drawer.id !== 'mini-cart' && !drawer.closest('#mini-cart'))
          .some((drawer) => drawer.hasAttribute('open'));

        this.headerElement.classList.toggle('ue-header--drawer-open', anyOpen);
      };

      /* 서랍 하나하나에 붙이지 않고 문서 전체의 open 속성 변화를 본다.
         테마가 서랍을 나중에 body 밑으로 옮기거나 새로 만들어도 놓치지 않기 위해서다. */
      this.drawerObserver = new MutationObserver(sync);
      this.drawerObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['open'],
        subtree: true
      });

      sync();
    }

    /* 담긴 것이 없으면 개수 뱃지를 띄우지 않는다 — 0 은 알릴 내용이 아니다 (3차 검수 G3-9).
       숫자는 테마의 cart-count 요소가 담기·빼기 때마다 바꾸므로 그 변화를 지켜본다. */
    _watchCartCount() {
      const counts = this.headerElement
        ? this.headerElement.querySelectorAll('.ue-header__actions .header__cart-count')
        : [];

      if (counts.length === 0) {
        return;
      }

      const sync = () => {
        counts.forEach((count) => {
          const value = parseInt(count.textContent.trim(), 10);
          count.classList.toggle('ue-cart-count--empty', !value);
        });
      };

      this.cartCountObserver = new MutationObserver(sync);

      counts.forEach((count) => {
        this.cartCountObserver.observe(count, { childList: true, characterData: true, subtree: true });
      });

      sync();
    }

    _onFocus() {
      const term = this.inputElement.value.trim();

      if (term === '') {
        // 빈 상태에서는 바로가기 메뉴만 보여 준다 (있을 때만)
        if (this.menuElement) {
          this.menuElement.hidden = false;
          this.resultsElement.hidden = true;
          this.loadingElement.hidden = true;
          this.footerElement.hidden = true;
          this.open();
        }
        return;
      }

      if (term === this.lastTerm) {
        this.open();
      } else {
        this._search(term);
      }
    }

    _onKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.inputElement.blur();
      }
    }

    _onInput() {
      const term = this.inputElement.value.trim();

      if (this.resetElement) {
        this.resetElement.hidden = term === '';
      }

      if (term === '') {
        this.lastTerm = null;
        this.resultsElement.innerHTML = '';
        this.resultsElement.hidden = true;
        this.loadingElement.hidden = true;
        this.footerElement.hidden = true;

        if (this.menuElement) {
          this.menuElement.hidden = false;
          this.open();
        } else {
          this.close();
        }

        return;
      }

      this._search(term);
    }

    _onReset(event) {
      event.preventDefault();
      this.inputElement.value = '';
      this.inputElement.focus();
      this._onInput();
    }

    async _search(term) {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.lastTerm = term;

      this.open();

      if (this.menuElement) {
        this.menuElement.hidden = true;
      }

      this.footerElement.hidden = true;
      this.resultsElement.hidden = true;
      this.loadingElement.hidden = false;

      let searchResults;

      try {
        searchResults = this._supportsPredictiveApi()
          ? await this._doPredictiveSearch(term)
          : await this._doLiquidSearch(term);
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        this.loadingElement.hidden = true;
        return;
      }

      this.loadingElement.hidden = true;

      /* 먼저 보이게 한 뒤 채운다.
         숨은 채로 붙이면 탭 상자 폭이 0 이라 테마의 탭 활성 표시가
         scale = 0/0 = NaN 이 되어 밑줄이 두 탭에 다 걸린다 (1차 16 · 2차 G-11). */
      this.resultsElement.hidden = false;
      this.resultsElement.innerHTML = searchResults.html;
      this.footerElement.hidden = !searchResults.hasResults;

      this._refreshTabIndicator();
    }

    /* 붙인 뒤에도 한 번 더 다시 재게 한다 (글꼴 늦게 뜨는 경우 대비) */
    _refreshTabIndicator() {
      const nav = this.resultsElement.querySelector('tabs-nav');

      if (!nav) {
        return;
      }

      requestAnimationFrame(() => {
        if (typeof nav._adjustNavigationPosition === 'function') {
          nav._adjustNavigationPosition(false);
        }
      });
    }

    async _doPredictiveSearch(term) {
      const url = `${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[limit]=${this.limit}&resources[limit_scope]=each&section_id=predictive-search`;
      return this._fetchSection(url);
    }

    /* 예측 검색 API를 지원하지 않는 언어에서는 일반 검색으로 되돌아간다 (Focal과 같은 방식) */
    async _doLiquidSearch(term) {
      const url = `${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(term)}&resources[limit]=50&section_id=predictive-search-compatibility`;
      return this._fetchSection(url);
    }

    async _fetchSection(url) {
      const response = await fetch(url, { signal: this.abortController.signal });
      const wrapper = document.createElement('div');

      wrapper.innerHTML = await response.text();

      return {
        hasResults: wrapper.querySelector('.predictive-search__results-categories') !== null,
        html: wrapper.firstElementChild ? wrapper.firstElementChild.innerHTML : ''
      };
    }

    _supportsPredictiveApi() {
      const featuresElement = document.getElementById('shopify-features');

      if (!featuresElement) {
        return true;
      }

      try {
        return JSON.parse(featuresElement.innerHTML)['predictiveSearch'] !== false;
      } catch (error) {
        return true;
      }
    }

    _debounce(fn, delay) {
      let timer = null;

      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  }

  window.customElements.define('ue-predictive-search', UePredictiveSearch);
})();

/* 안내문 바꿔치기는 **없앴다** (2026-09-11 19:4x). CSS 가 폭에 따라 고르므로 자바스크립트가 할 일이 없다.
   예전에는 여기서 placeholder 를 바꿨고, 그래서 모바일에서 긴 문장이 한순간 보였다. */
(() => { try { sessionStorage.removeItem('ue_mobile'); } catch (e) {} })();

/* 전체 카테고리 판 여닫기 (데스크톱 ALL 단추) — 의장 2026-09-11 18:4x
   「데스크톱에서 햄버거 누르면 옆에서 나오는데 아래로 펼쳐지게 변경해」
   Focal 의 toggle-button 은 서랍(옆에서 미는 것) 전용이라 쓰지 않고 여기서 직접 연다.
   닫는 길을 셋 둔다 — 단추 다시 누르기 · 바깥 누르기 · Esc. */
(() => {
  const 판ID = 'ue-all-panel';
  let 막 = null;

  const 판 = () => document.getElementById(판ID);
  const 단추들 = () => [...document.querySelectorAll('[data-action="ue-toggle-all"]')];

  function 닫기() {
    const p = 판();
    if (!p || p.hidden) return;
    p.hidden = true;
    단추들().forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (막) { 막.remove(); 막 = null; }
  }

  function 열기() {
    const p = 판();
    if (!p) return;
    // 검색 결과 판이 열려 있으면 먼저 닫는다 — 둘이 같은 자리에 겹친다
    const 검색판 = document.querySelector('.ue-search__panel');
    if (검색판 && !검색판.hidden) 검색판.hidden = true;

    p.hidden = false;
    단추들().forEach((b) => b.setAttribute('aria-expanded', 'true'));
    막 = document.createElement('div');
    막.className = 'ue-all-scrim';
    막.addEventListener('click', 닫기);
    p.parentNode.insertBefore(막, p);
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-action="ue-toggle-all"]');
    if (b) {
      e.preventDefault();
      const p = 판();
      if (p && p.hidden) 열기(); else 닫기();
      return;
    }
    const p = 판();
    if (p && !p.hidden && !e.target.closest('#' + 판ID)) 닫기();
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') 닫기(); });
  window.addEventListener('resize', () => { if (window.innerWidth < 가로메뉴폭) 닫기(); });
})();

/* TIME DEAL 자리표는 이제 sections/ue-time-sale.liquid 안에 **진짜로** 들어 있다 (2026-09-11 19:3x).
   자바스크립트로 늦게 심으면 홈 첫 화면을 한 번 그린 뒤 내려가서 히어로가 번쩍인다. 여기서는 아무것도 하지 않는다. */

/* 브랜드 판 — BRAND 에 마우스를 올리면 열리고, 글자를 누르면 그 글자만 남는다.
   (의장 2026-09-11 19:0x 「BRAND를 메뉴에 넣고 마우스오버하면 이렇게 되게 할 수 있어?」 · JOLSE 방식)
   마우스가 메뉴에서도 판에서도 벗어나면 닫는다. 손가락으로 쓰는 화면에서는 눌러도 열린다. */
(() => {
  const 판 = () => document.getElementById('ue-brand-panel');
  const 단추 = () => document.querySelector('[data-action="ue-brand-open"]');
  let 닫기예약 = null;

  function 글자정리() {
    const p = 판();
    if (!p || p.dataset.ready === '1') return;
    const 있는글자 = new Set([...p.querySelectorAll('.ue-brand-panel__group')].map((g) => g.dataset.letter));
    p.querySelectorAll('.ue-brand-panel__letter').forEach((b) => {
      const k = b.dataset.pick;
      if (k !== 'ALL' && !있는글자.has(k)) b.disabled = true;   // 브랜드가 없는 글자는 누를 수 없게
    });
    p.dataset.ready = '1';
  }

  function 고르기(k) {
    const p = 판();
    if (!p) return;
    p.querySelectorAll('.ue-brand-panel__letter').forEach((b) => b.classList.toggle('is-on', b.dataset.pick === k));
    let 보임 = 0;
    p.querySelectorAll('.ue-brand-panel__group').forEach((g) => {
      const 맞나 = k === 'ALL' || g.dataset.letter === k;
      g.hidden = !맞나;
      if (맞나) 보임++;
    });
    let 빈말 = p.querySelector('.ue-brand-panel__empty');
    if (보임 === 0) {
      if (!빈말) {
        빈말 = document.createElement('p');
        빈말.className = 'ue-brand-panel__empty';
        빈말.textContent = 'No brands under this letter yet.';
        p.querySelector('.ue-brand-panel__names').appendChild(빈말);
      }
      빈말.hidden = false;
    } else if (빈말) {
      빈말.hidden = true;
    }
  }

  function 열기() {
    const p = 판(); const b = 단추();
    if (!p || !b) return;
    clearTimeout(닫기예약);
    const 다른판 = document.getElementById('ue-all-panel');
    if (다른판 && !다른판.hidden) 다른판.hidden = true;
    글자정리();
    p.hidden = false;
    b.setAttribute('aria-expanded', 'true');
  }

  function 닫기() {
    const p = 판(); const b = 단추();
    if (!p || p.hidden) return;
    p.hidden = true;
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function 늦게닫기() {
    clearTimeout(닫기예약);
    닫기예약 = setTimeout(닫기, 180);   // 메뉴와 판 사이를 지나갈 틈을 준다
  }

  document.addEventListener('mouseover', (e) => {
    if (window.innerWidth < 가로메뉴폭) return;
    if (e.target.closest('[data-action="ue-brand-open"]') || e.target.closest('#ue-brand-panel')) 열기();
  });

  document.addEventListener('mouseout', (e) => {
    if (window.innerWidth < 가로메뉴폭) return;
    const 안쪽 = e.target.closest('[data-action="ue-brand-open"]') || e.target.closest('#ue-brand-panel');
    if (!안쪽) return;
    const 간곳 = e.relatedTarget;
    if (간곳 && (간곳.closest('[data-action="ue-brand-open"]') || 간곳.closest('#ue-brand-panel'))) return;
    늦게닫기();
  });

  document.addEventListener('click', (e) => {
    const 글자 = e.target.closest('.ue-brand-panel__letter');
    if (글자) { e.preventDefault(); 고르기(글자.dataset.pick); return; }
    const b = e.target.closest('[data-action="ue-brand-open"]');
    if (b && window.innerWidth >= 가로메뉴폭) {
      // 손가락으로 쓰는 화면: 첫 번째 누름은 판을 연다
      const p = 판();
      if (p && p.hidden) { e.preventDefault(); 열기(); return; }
    }
    if (!e.target.closest('#ue-brand-panel')) 닫기();
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') 닫기(); });
  window.addEventListener('resize', () => { if (window.innerWidth < 가로메뉴폭) 닫기(); });
})();


/* ───────────────────────────────────────────────────────────────────
   하위가 있는 상위 메뉴는 **이동하지 않고 하위만 펼친다** (2026-10-17 의장 ㉯)

   소서 개선점 18번 — 「Value 누르면 all products 페이지 연결됨」.
   재어 보니 VALUE 만이 아니라 **CATEGORIES 도 같다**. 둘 다 하위를 거느린 상위인데
   링크가 `/collections/all-products` 로 잡혀 있다.

   ⚠ 그 링크의 주인은 **쇼피파이 관리자 탐색**이고 **라이브와 같은 메뉴**를 쓴다.
      관리자에서 고치면 판매 중 사이트 메뉴가 같이 바뀐다 — 그래서 **테마에서만** 막는다.
   ⚠ 모바일 서랍은 이미 `<button>`(하위 열기)이라 건드리지 않는다. **데스크톱만**이다.
   ⚠ 하위 표시는 테마 자신의 장치를 그대로 쓴다 — `.nav-dropdown` 은
      `hidden` 속성이 빠져 있을 때만 보인다(theme.css 8113줄).
   ─────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var 가로메뉴폭 = 1060;   /* 0-3-확정절: 1060 이상이 데스크톱 판 */

  function 하위(li) {
    return li ? li.querySelector(':scope > .nav-dropdown') || li.querySelector('.nav-dropdown') : null;
  }

  function 모두닫기(빼고) {
    document.querySelectorAll('.header__linklist-item.has-dropdown').forEach(function (li) {
      if (li === 빼고) { return; }
      var d = 하위(li);
      if (d && !d.hasAttribute('hidden')) { d.setAttribute('hidden', ''); }
      var a = li.querySelector('a.header__linklist-link');
      if (a) { a.setAttribute('aria-expanded', 'false'); }
    });
  }

  document.addEventListener('click', function (e) {
    if (window.innerWidth < 가로메뉴폭) { return; }          /* 모바일은 서랍이 맡는다 */
    if (!e.target.closest) { return; }

    var a = e.target.closest('a.header__linklist-link');
    if (!a) { return; }

    var li = a.closest('.header__linklist-item');
    var d = 하위(li);
    if (!d) { return; }                                       /* 하위가 없는 메뉴는 그대로 이동한다 */

    e.preventDefault();                                       /* all-products 로 가지 않는다 */

    var 열려있었나 = !d.hasAttribute('hidden');
    모두닫기(li);
    if (열려있었나) {
      d.setAttribute('hidden', '');
      a.setAttribute('aria-expanded', 'false');
    } else {
      d.removeAttribute('hidden');
      a.setAttribute('aria-expanded', 'true');
    }
  }, true);

  /* 닫는 길 둘 — 바깥 누르기 · Esc */
  document.addEventListener('click', function (e) {
    if (window.innerWidth < 가로메뉴폭) { return; }
    if (e.target.closest && e.target.closest('.header__linklist-item.has-dropdown')) { return; }
    모두닫기(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { 모두닫기(null); }
  });
})();

